
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Users, Trophy, FlaskConical, Cloud } from 'lucide-react';

const BackersSection = () => {
  return (
    <div id="backers" className="space-y-12">
      <div className="space-y-6">
        <h2 className="text-3xl font-bold font-mono">What Sets Us Apart</h2>
        <div className="grid md:grid-cols-2 gap-6">
          <Card className="border-primary/20">
            <CardContent className="pt-6">
              <h3 className="text-xl font-semibold mb-2">Domain‑Tuned RL & Fine‑Tuning</h3>
              <p className="text-muted-foreground">
                Purpose‑built pipelines extract optimal performance from foundation models while respecting enterprise constraints.
              </p>
            </CardContent>
          </Card>
          <Card className="border-primary/20">
            <CardContent className="pt-6">
              <h3 className="text-xl font-semibold mb-2">Proven Scale</h3>
              <p className="text-muted-foreground">
                Experience running thousands of RL experiments per day and serving billions of inferences in production.
              </p>
            </CardContent>
          </Card>
          <Card className="border-primary/20">
            <CardContent className="pt-6">
              <h3 className="text-xl font-semibold mb-2">Research‑Driven, Results‑Focused</h3>
              <p className="text-muted-foreground">
                Our published work on GRPO and RLHF methods continually feeds best practices back into client engagements.
              </p>
            </CardContent>
          </Card>
          <Card className="border-primary/20">
            <CardContent className="pt-6">
              <h3 className="text-xl font-semibold mb-2">Full‑Stack Integration</h3>
              <p className="text-muted-foreground">
                From data engineering to secure deployment, we meet you where your stack lives—cloud, on‑prem, or hybrid.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>

      <div className="space-y-6">
        <h2 className="text-3xl font-bold font-mono">Our Backers & Advisors</h2>
        <Card className="border-primary/20">
          <CardContent className="pt-6 space-y-4">
            <div className="space-y-2">
              <h3 className="text-xl font-semibold">Investment Partners</h3>
              <p className="text-muted-foreground">Y Combinator, Costanoa Ventures, and Goodwater Capital</p>
            </div>
            <div className="space-y-2">
              <h3 className="text-xl font-semibold">Key Advisors</h3>
              <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-2">
                <li>Logan Kilpatrick (OpenAI)</li>
                <li>Alex Graveley (GitHub Copilot creator)</li>
                <li>Tom Preston‑Werner (GitHub co‑founder)</li>
                <li>Flo Crivello (Lindy.ai founder)</li>
                <li>Immad Akhund (Mercury founder)</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default BackersSection;
